'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tabs = function Tabs(_ref) {
    var activeTabIndex = _ref.activeTabIndex,
        activeTabClassName = _ref.activeTabClassName,
        collapsed = _ref.collapsed,
        containerClassName = _ref.containerClassName,
        onKeyDownTab = _ref.onKeyDownTab,
        onSelectTab = _ref.onSelectTab,
        tabClassName = _ref.tabClassName,
        tabLabels = _ref.tabLabels,
        theme = _ref.theme;

    var style = theme;
    return style ? _react2.default.createElement(
        'ul',
        { className: (0, _classnames2.default)(style.tabs, containerClassName, (0, _defineProperty3.default)({}, style.collapsed, collapsed)) },
        tabLabels.map(function (tabLabel, index) {
            var active = activeTabIndex === index;
            var finalTabClassName = (0, _classnames2.default)(style.tab, (0, _defineProperty3.default)({}, (0, _classnames2.default)(style.active, activeTabClassName), active), tabClassName);
            return _react2.default.createElement(
                'li',
                {
                    className: finalTabClassName,
                    key: [index, tabLabel].join('_'),
                    role: 'tablist'
                },
                _react2.default.createElement(
                    'a',
                    {
                        className: style.tabItem,
                        'aria-selected': active ? 'true' : 'false',
                        onClick: onSelectTab ? onSelectTab(index) : undefined,
                        onKeyDown: onKeyDownTab ? onKeyDownTab(index) : undefined,
                        onFocus: onSelectTab ? onSelectTab(index) : undefined,
                        role: 'tab'
                    },
                    tabLabel
                )
            );
        })
    ) : null;
};

Tabs.displayName = 'Tabs';

exports.default = Tabs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Tabs/index.js
// module id = ./node_modules/dibs-elements/lib/Tabs/index.js
// module chunks = 4